import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HeadwordSearchService {
  nResults = 200;
  headsRequest: Observable<string[]>;

  constructor(private httpClient: HttpClient) {
    this.headsRequest = this.httpClient.get<string[]>(environment.backendUrl + 'static/heads.json').pipe(shareReplay(1));
  }

  search(term: string): Observable<string[]> {
    return this.headsRequest.pipe(map(value => value.filter(word => word.startsWith(term)).slice(0, this.nResults)));
  }

  includes(term: string): Observable<boolean> {
    return this.headsRequest.pipe(map(value => value.includes(term)));
  }

}
